import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class ApiUserDetailsService {
    baseUrl: string = 'apiUserDetails.svc'; 
    constructor(private http: Http, private _ajaxService: AjaxService) {
    }
    save(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/save", dataToBePost);        
    }
    delete(id) {        
        return this._ajaxService.GET(this.baseUrl + "/delete/" + id);        
    }
    select(id) {        
        return this._ajaxService.GET(this.baseUrl + "/select/"+id);        
    }
    all(pageIndex, pageSize, sortHeaderName, sortDirection, filterText) {        
        return this._ajaxService.GET(this.baseUrl + "/all/" + pageIndex + "/" + pageSize + "/" + sortHeaderName + "/" + sortDirection + "/" + filterText); 
    }
    generateApiKey(id, apiKey, dataToBePost) {        
        return this._ajaxService.PUT(this.baseUrl + "/generateapikey/" + id + '/' + apiKey , dataToBePost);        
    }
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/api.user.details.service.ts